export default {
  title: 'Users',
  user: 'User',
  users: 'Users',

  titles: {
    create: 'Create a new user',
    token: 'API key',
    presets: 'Presets',

    add: {
      funds: 'Add funds'
    }
  },

  contents: {
    routingGroups: {
      confirm: {
        remove: 'Confirm removing the routing group only from the current user settings.'
      }
    }
  },

  labels: {
    owner: 'Owner',
    username: 'Username',
    password: 'Password',
    reseller: 'Reseller',
    manager: 'Manager',
    referralCode: 'User referral code',
    target: 'no sender names | one sender name | {count} sender names',
    sendernames: 'Sender names',
    patterns: 'Patterns',

    isActive: {
      true: 'Cabinet access is allowed',
      false: 'Cabinet access is restricted'
    },

    strict: {
      true: 'Strict matching is enabled',
      false: 'Strict matching is disabled',
      undefined: 'Strict matching is undefined'
    },

    data: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'E-mail',
      phone: 'Phone',

      partnership: {
        hasContract: {
          true: 'Contract is signed',
          false: 'Contract is not signed',
          undefined: 'Contract status is undefined'
        }
      },

      meta: {
        source: 'Source',
        usedReferralCode: 'Used referral code'
      }
    },

    no: {
      manager: 'No manager'
    }
  },

  tabs: {
    general: 'General',
    settings: 'Settings',
    settingsUser: 'Settings',
    permissions: 'Permissions',
    tariffs: 'Tariffs',
    routingGroups: 'Routes',
    processMessages: 'Process messages',
    requisites: 'Requisites',
    whatsapp: 'WhatsApp',
    recurrentPayments: 'Auto payments',
    referral: 'Referral top-ups',
    tokens: 'Tokens',
    eventsHistory: 'Events history',
    eventsHistoryTab: 'History of changes',
    userComments: 'Comments',
    userChannels: 'OTP Channels',
    domainsUsers: 'Domains',
    advanced: 'Advanced',
    granular: 'Granular',
    secret: 'Secret'
  },

  hints: {
    password: 'Create a secure password'
  },

  infos: {
    associationsByType: `
<strong>The strict matching switch</strong> is a separate user setting.
It is not related to user data.<br>
To avoid accidental enabling or disabling, a
confirmation button <strong>Save</strong> was added.<br><br>

<i>After each change of the switch</i> for strict matching, you need to
click <strong>Save</strong>, because now this change is not saved
automatically.<br><br>

If strict matching is enabled for the <strong>Sender names</strong> field,
the user will be able to use only the selected sender names when creating
a message.<br>
If strict matching is enabled for the <strong>Patterns</strong> field,
only the selected patterns will be applied during moderation of user
messages.<br><br>

The <strong>Sender names</strong> and
<strong>Patterns</strong> fields are part of user data.<br>
Changes in these fields are saved only by pressing the
<strong>Update</strong> button.
`
  },

  warnings: {
    apiKey: 'Unfortunately, generated API key exceeds permissible length. Please, try changing username and reloading page afterwards, or contact your manager for help.',
    noTypes: 'No available sending types.',

    permissions: {
      strict: {
        sendernames: 'You do not have enough permissions to view strict sender name matching.',
        patterns: 'You do not have enough permissions to view strict pattern matching.'
      }
    }
  },

  errors: {
    permissions: {
      get: {
        messageRuleGroups: 'You do not have enough permissions to view message processing rule groups.'
      }
    }
  },

  tooltips: {
    name: 'Name: {name}',
    overdraft: 'Overdraft: {overdraft}',
    reseller: 'Reseller: {reseller}',
    manager: 'Manager: {manager}',
    isActive: 'This flag controls the user access to the platform. This is part of the user data, so changes are saved only after clicking the "Update" button.',
    isVerifiedByPhone: 'Phone is verified, changes are disabled. If you want to change the phone number, please contact support.',
    user: `First name: {firstName}
Last name: {lastName}
Phone: {phone}
E-mail: {email}
`,

    data: {
      meta: {
        isVerifiedByPhone: 'Enables or disables phone verification. The change is saved only after clicking the "Update" button.'
      }
    },

    add: {
      funds: 'Add funds'
    },

    generate: {
      document: 'Download document',
      password: 'Generate password'
    },

    copy: {
      apiKey: 'Copy API key',

      referral: {
        code: 'Copy referral code',
        link: 'Copy referral link'
      }
    },

    strict: {
      sendernames: 'The user will be able to use only sender names selected in the field below when creating a message.',
      patterns: 'During moderation of user messages, only patterns selected in the field below will be applied.'
    }
  },

  buttons: {
    account: 'Profile',
    password: 'Change password'
  },

  snackbars: {
    created: 'User successfully created.',
    updated: 'User successfully updated.',
    removed: 'User successfully removed.',
    linkCopied: 'Link copied successfully.',
    refCopied: 'Referral code copied successfully.',

    copy: {
      apiKey: 'API key copied successfully.'
    }
  }
}
